import { create } from 'zustand'

interface MenuSidebarState {
  isOpen: boolean
  setIsOpen: (value: boolean) => void
  reset: () => void
}

export const useMenuSidebarStore = create<MenuSidebarState>(set => ({
  isOpen: false,
  setIsOpen: value => set({ isOpen: value }),
  reset: () => set({ isOpen: false })
}))
